<app-data-table
  title="Development Partner Account"
  url="devt-partners"
  type="devt-partners"
></app-data-table>
